import type { ContractLineFormItem } from '../types/contractForm';
import type { ICcIdResponse } from '../types/dtos';

/** Infere DDD para linha Aditivo automática (suspensão): prioriza linhas marcadas / Reneg suspensa. */
export function inferDddForSuspensionAutoAditivo(
  lines: ContractLineFormItem[],
  linhasParaDesativar?: Set<string>
): string {
  if (linhasParaDesativar && linhasParaDesativar.size > 0) {
    const marked = lines.find(
      (l) => linhasParaDesativar.has(l.id ?? '') && (l.ddd ?? '').trim()
    );
    if (marked?.ddd) return marked.ddd.trim();
  }

  const suspendedReneg = lines.find(
    (l) =>
      l.negociacao === 'Renegociação' &&
      (l.excluirDoContrato || l.requerSuspensao) &&
      (l.ddd ?? '').trim()
  );
  if (suspendedReneg?.ddd) return suspendedReneg.ddd.trim();

  const reneg = lines.find((l) => l.negociacao === 'Renegociação' && (l.ddd ?? '').trim());
  if (reneg?.ddd) return reneg.ddd.trim();

  const aditivo = lines.find(
    (l) => l.negociacao === 'Aditivo' && !l.excluirDoContrato && (l.ddd ?? '').trim()
  );
  return aditivo?.ddd?.trim() ?? '';
}

export function collectUsedIccids(
  lines: ContractLineFormItem[],
  excludeLineId?: string
): Set<string> {
  return new Set(
    lines
      .filter((l) => !excludeLineId || l.id !== excludeLineId)
      .map((l) => (l.chipCcid || '').trim())
      .filter(Boolean)
  );
}

export function pickRandomAvailableIccid(
  ddd: string,
  ccidsEmUso: Set<string>,
  buildPool: (line: { ddd?: string; isEsim?: boolean }) => ICcIdResponse[],
  isEsim = false
): string {
  const dddTrim = ddd.trim();
  if (!dddTrim) return '';

  const available = buildPool({ ddd: dddTrim, isEsim }).filter((ic) => {
    const ccid = (ic.ccId || '').trim();
    return ccid.length > 0 && !ccidsEmUso.has(ccid);
  });
  if (available.length === 0) return '';

  const picked = available[Math.floor(Math.random() * available.length)];
  return (picked.ccId || '').trim();
}
